const { divIcon } = require("leaflet");

(function($) {
	$.whatsappButton = function(opciones_usuario) {
		var opciones_por_defecto = {
			number: "56999999999",
			profilePhoto: "https://randomuser.me/api/portraits/lego/5.jpg",
			message: "Hola, ¿En qué podemos ayudarte?",
			iconButton:
				"https://assets.stickpng.com/thumbs/580b57fcd9996e24bc43c543.png",
			iconWidth: 40,
			iconHeight: 40,
			top: "unset",
			right: "unset",
			bottom: "unset",
			left: "unset",
			chatMode: true,
			sendMessageIcon:
				"https://www.seekpng.com/png/full/51-512819_png-file-svg-whatsapp-send-icon-png.png",
		};
		var opt = $.extend(opciones_por_defecto, opciones_usuario);

		$("html").append(
			$("<div>").attr({
				id: "whatsappButton",
			})
		);
		$("#whatsappButton")
			.css({
				position: "fixed",
				"z-index": 99999,
				top: Number.isInteger(opt.top) ? opt.top + "px" : opt.top,
				right: Number.isInteger(opt.right)
					? opt.right + "px"
					: opt.right,
				bottom: Number.isInteger(opt.bottom)
					? opt.bottom + "px"
					: opt.bottom,
				left: Number.isInteger(opt.left) ? opt.left + "px" : opt.left,
			})
			.append(
				$("<a>")
					.addClass("iconButton")
					.css({
						position: "relative",
						"text-align": "center",
					})
					.append(
						$("<img>")
							.attr({
								src: opt.iconButton,
							})
							.css({
								"box-shadow":
									"2px 0px 9px 0px rgba(0, 0, 0, 0.4)",
								"border-radius": "100% 100% 100% 4%",
								position: "relative",
								width: opt.iconWidth,
								height: opt.iconHeight,
							})
					)
			);

		$.isMobile = function() {
			var isMobile = false; //initiate as false
			// device detection
			if (
				/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
					navigator.userAgent
				) ||
				/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
					navigator.userAgent.substr(0, 4)
				)
			) {
				isMobile = true;
			}
			return isMobile;
		};

		if (opt.chatMode) {
			if (!$.isMobile()) {
				$.sendMessage = function() {
					var mensaje = $("#fakeChat")
						.find(".messageText")
						.val();

					mensaje = mensaje.replace(/ /g, "%20");
					window.open(
						"https://wa.me/" + opt.number + "?text=" + mensaje,
						"_blank"
					);
					$("#fakeChat")
						.find(".messageText")
						.val("");
				};

				$("#whatsappButton").prepend(
					$("<div>")
						.attr({ id: "fakeChat" })
						.css({
							"border-radius": "10px",
							overflow: "hidden",
							"box-shadow": "1px 1px 6px 1px rgba(0,0,0,.4)",
							display: "none",
						})
						.append(
							$("<div>")
								.addClass("encabezado")
								.css({
									background: "#075e55",
									color: "#FFFFFF",
									padding: "15px",
									display: "flex",
									"align-items": "center",
								})
								.append(
									$("<img>")
										.attr({
											src: opt.profilePhoto,
										})
										.css({
											width: "30px",
											height: "30px",
											"border-radius": "100%",
											"margin-right": "15px",
										})
								)
								.append(
									$("<strong>")
										.text("+" + opt.number)
										.css({
											"flex-grow": 2,
										})
								)
								.append(
									$("<a>")
										.html("&Cross;")
										.attr({
											href: "javascript:void(null);",
										})
										.css("color", "#FFFFFF")
										.on("click", function() {
											$("#fakeChat").slideUp(function() {
												$(this)
													.find(".messageText")
													.val("");
												$(
													"#whatsappButton .iconButton"
												).fadeIn(function() {});
											});
										})
								)
						)
						.append(
							$("<div>")
								.addClass("mensajes")
								.css({
									background: "#efece7",
									padding: "10px 10px 100px",
									width: "340px",
								})
								.append(
									$("<div>")
										.addClass("mensaje")
										.css({
											display: "flex",
											"align-items": "flex-start",
										})

										.append(
											$("<div>")
												.text(opt.message)
												.css({
													background: "#FFFFFF",
													color: "#212121",
													"border-radius": "5px",
													padding: "5px 10px",
													display: "inline",
													"box-shadow":
														"0px 1px 5px 1px rgba(0,0,0,.4)",
													display: "flex",
												})
										)
								)
						)
						.append(
							$("<div>")
								.addClass("pie")
								.css({
									display: "flex",
									"align-items": "flex-start",
									position: "relative",
								})
								.append(
									$("<textarea>")
										.attr({
											class: "messageText",
											rows: 1,
										})
										.css({
											padding: "10px 45px 10px 10px",
											display: "block",
											width: "100%",
											color: "#212121",
											"min-height": "60px",
											border: 0,
										})
								)

								.append(
									$("<img>")
										.attr({
											src: opt.sendMessageIcon,
										})
										.css({
											background: "#075e55",
											"border-radius": "100%",
											padding: "5px",
											position: "absolute",
											right: "6px",
											top: "15px",
											width: "34px",
											cursor: "pointer",
										})
										.on("click", function() {
											$.sendMessage();
										})
								)
						)
				);

				$("#whatsappButton .iconButton")
					.attr({ href: "javascript:void(null);" })
					.on("click", function(e) {
						$(this).fadeOut(function() {
							$("#fakeChat").slideDown(function() {
								$(this)
									.find(".messageText")
									.focus();
							});
						});
					});
			} else {
				$("#whatsappButton .iconButton").attr({
					href: "https://wa.me/" + opt.number,
					target: "_blank",
				});
			}
		} else {
			if ($.isMobile()) {
				$("#whatsappButton .iconButton").attr({
					href: "https://wa.me/" + opt.number,
					target: "_blank",
				});
			} else {
				$("#whatsappButton .iconButton")
					.prepend(
						$("<div>")
							.addClass("message")
							.text(opt.message)
							.css({
								padding: "5px 15px",
								margin: "0 0 2px 0",
								background: "#1EBEA5",
								color: "#FFFFFF",
								"border-radius": "50px",
								display: "none",
								position: "absolute",
								"white-space": "nowrap",
								right: Number.isInteger(opt.right)
									? 0
									: "unset",
								left: Number.isInteger(opt.left) ? 0 : "unset",
							})
					)
					.attr({
						href: "https://wa.me/" + opt.number,
						target: "_blank",
					});

				if (opt.message) {
					$("#whatsappButton")
						.mouseover(function(e) {
							$(this)
								.find(".message")
								.css({ top: "-" + $(this).height() + "px" })
								.stop()
								.fadeIn();
						})
						.mouseout(function(e) {
							$(this)
								.find(".message")
								.stop()
								.fadeOut();
						});
				}
			}
		}
	};
})(jQuery);
